import React from 'react';
import { Tooltip, TooltipProps } from '@fiverr-private/tooltip';
import { QuestionMarkIcon } from '@fiverr-private/visuals';
import { Container } from '@fiverr-private/layout_components';
import { type Types } from '@fiverr-private/theme';
import { FORM_TOOLTIP_ID } from '../../constants';

interface FormTooltipProps extends Pick<Types.BoxType, 'dataTrackTag' | 'dataTrackValue'> {
  content: TooltipProps['content'];
}

const FormTooltip = ({ content, dataTrackTag = 'form_tooltip', dataTrackValue }: FormTooltipProps) => (
  <Tooltip dataTrackTag={dataTrackTag} dataTrackValue={dataTrackValue} content={content}>
    <Container as="span" display="flex">
      <QuestionMarkIcon color="grey_900" />
    </Container>
  </Tooltip>
);

FormTooltip.id = FORM_TOOLTIP_ID;
FormTooltip.displayName = FORM_TOOLTIP_ID;

export default FormTooltip;
